import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {
    Col,
    Row,
    Form,
    Checkbox,
    FormGroup
} from 'react-bootstrap';

import {
    validateEmail,
    settingsChangedAction
} from '../../actions/SettingsActions';


const mapStateToProps = (state) => ({
    ...state.settingsReducer,
    primaryEmail: state.meReducer.me.primaryEmail,
    event: state.eventReducer.event,
    isRingWorks: state.ringReducer.isRingWorks
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    validateEmail,
    settingsChangedAction
}, dispatch);

const EmailPushSettingLine = ({children, state, email, push, onChange, readOnly}) => (
    <div>
        <FormGroup>
            <Col xs={12} md={8}>
                <div>{children}</div>
            </Col>
            <Col xs={12} md={4}>
                <Checkbox className="settings-inline-checkbox"
                    inline
                    disabled={readOnly}
                    onChange={e => onChange(push, e.target.checked)}
                    checked={state[push]}>
                    <span>Push Notifications</span>
                </Checkbox>
                {' '}
                <Checkbox className="settings-inline-checkbox"
                    inline
                    disabled={readOnly}
                    onChange={e => onChange(email, e.target.checked)}
                    checked={state[email]}>
                    <span>Email</span>
                </Checkbox>
            </Col>
        </FormGroup>
    </div>
);

class SettingsView extends Component {

    onCheckboxChange(name, checked) {
        this.props.settingsChangedAction(name, checked);
    }

    onValidateEmailClick() {
        this.props.validateEmail(this.props.event.id);
    }

    render() {
        const { isRingWorks, settings, emailValidation } = this.props;
        return (
            <div className="main-settings-container container">
                <h1>Settings</h1>
                <Row>
                    <Col xs={12}>
                        <h4>These general settings will be applied across all events associated with the logged in user
                            profile.</h4>
                    </Col>
                </Row>



                <Form horizontal>
                    <fieldset>
                        <h3>Announcements</h3>

                        <EmailPushSettingLine
                            state={settings}
                            onChange={(key, value) => this.onCheckboxChange(key, value)}
                            email="emailNotifications"
                            push="notificationsPush">
                            When the event organizer shares a special announcement
                        </EmailPushSettingLine>

                        <EmailPushSettingLine
                            state={settings}
                            onChange={(key, value) => this.onCheckboxChange(key, value)}
                            email="emailChat"
                            push="chatPush">
                            When an attendee sends me a personal message
                        </EmailPushSettingLine>
                    </fieldset>

                    <fieldset>
                        <h3>Who Viewed My Profile</h3>

                        <div className="margin-bottom-small">
                            <Checkbox inline
                                checked={settings.profileViewActivity}
                                onChange={e => this.onCheckboxChange('profileViewActivity', e.target.checked)}>
                                Share my profile views with others</Checkbox>
                            <div className="setting-more-info">Let others see that I viewed their profile. When set to
                                off you will not be able to see who viewed your profile.
                            </div>
                        </div>

                        <EmailPushSettingLine
                            state={settings}
                            readOnly={!settings.profileViewActivity}
                            onChange={(key, value) => this.onCheckboxChange(key, value)}
                            email="emailProfileView"
                            push="profileViewPush">
                            When attendees view my profile
                        </EmailPushSettingLine>
                    </fieldset>

                    {!isRingWorks && (
                        <fieldset>
                            <h3>Join Community Activity</h3>

                            <div className="margin-bottom-small">
                                <Checkbox inline
                                    checked={settings.shareActivity}
                                    onChange={e => this.onCheckboxChange('shareActivity', e.target.checked)}>
                                    Share my Joined Events with my connections</Checkbox>

                                <div className="setting-more-info">When set to OFF you will not be able to get
                                    notifications of other Joined connections
                                </div>
                            </div>


                            <EmailPushSettingLine
                                state={settings}
                                readOnly={!settings.shareActivity}
                                onChange={(key, value) => this.onCheckboxChange(key, value)}
                                email="emailConnectionActivity"
                                push="connectionsActivity">
                                Notify me when my LinkedIn connections join an event community
                            </EmailPushSettingLine>

                        </fieldset>
                    )}
                </Form>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsView);
